import { Box, CircularProgress } from "@mui/material";
import { createContext } from "react";

export const DashboardContentLoadingContext = createContext(false);

const MainContentLoader = () => (
  <Box
    role="status"
    aria-label="Loading page content"
    sx={{
      minHeight: "calc(100vh - 120px)",
      display: "grid",
      placeItems: "center",
    }}
  >
    <CircularProgress aria-hidden="true" />
  </Box>
);

export default MainContentLoader;
